
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef, HostListener} from '@angular/core';
import { LatestResultIconsDesktop, PollutionForecastTypes, WeatherForecastIcons } from 'src/app/models/app-constants';
import { SitePopupInfoModel } from 'src/app/models/SiteDetails/SitePopupInfoModel';
import { getForecastDateDescription } from 'src/app/shared/utils';

@Component({
	// standalone : true,
	selector: 'app-site-popup-info-widget',
	templateUrl: './site-popup-info-widget.component.html',
	styleUrls: ['./site-popup-info-widget.component.scss']		
})

export class SitePopupInfoWidgetComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() isFavouriteScreen : boolean = false;
	@Input() showScreenshot : boolean = false;	
	@Input() sitePopupInfo : SitePopupInfoModel;	
	@Input() mobileView? : boolean = false;
	@Input() sitePhoto : string = "";
	@Input() closable : boolean = false;
	@Output() closed : EventEmitter<any> = new EventEmitter<any>();

	
	ngOnInit(): void {

	}

	ngOnChanges(changes: SimpleChanges): void {		
		
	}

	ngAfterViewInit(): void 
	{		
	}
		
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (this.closable && "Escape" === event.key) {
			this.onCloseButtonClicked(event);
		}
	}

	onCloseButtonClicked = (event : any) => {
		this.closed.emit(event);
	}
}